import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import FormControl from '@mui/material/FormControl'
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel'
const ProductCost = ({open, close, ...rest}) => {
  const app = React.useContext(AppContext)
  const { selectedProducts, setSelectedProducts, assignCost, getProducts } = app.products
  const [cost, setCost] = React.useState()
  const costChange = (e) => {
    const target = e.target? e.target:e.currentTarget
    const value = Number(target.value)
    setCost(isNaN(value)?0:value)
  }
  const updateCost = () => {
    assignCost(cost)
    close()
  }
  const skus = (ps) => ps.reduce((pv, p) => pv ? `${pv}, ${p.sku}` : p.sku, false)
  const name = () => selectedProducts.length == 1? `Asignar Costo a: ${getProducts(selectedProducts)[0].name}`: `Asignar Costo a ${selectedProducts.length} productos con SKUs: (${skus(getProducts(selectedProducts))})`
  React.useEffect(() => {
    if(selectedProducts)
      selectedProducts.length == 1? setCost(getProducts(selectedProducts)[0].cost) : setCost(null)
  }, [selectedProducts])
  return (
    <Dialog onClose={() => setSelectedProducts(false)} open={open}>
    {selectedProducts && 
      <React.Fragment>
        <DialogTitle>{name()}</DialogTitle>
        <FormControl sx={{ m: 1, width: '25ch' }}>
          <InputLabel htmlFor="costo">Costo</InputLabel>
          <OutlinedInput
            id="costo"
            value={cost}
            onChange={costChange}
            startAdornment={<InputAdornment position="start">Centavos</InputAdornment>}
            label="Amount"
          />
        </FormControl>
        <Button disabled={isNaN(cost)} onClick={updateCost}>Actualizar costo</Button>
      </React.Fragment>
    }
    </Dialog>
  )
}
export default ProductCost